var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m5.30334 1.41951c-3.72998 1.58521-5.468662 5.89401-3.88346 9.62399 1.5852 3.73 5.894 5.4687 9.62402 3.8835.6909-.2937 1.3135-.6808 1.8593-1.1403l4.7818 4.7824.07.0605c.2447.1816.5919.1615.8138-.0604.2441-.2441.2442-.6398.0001-.8839l-4.7821-4.7828c1.7228-2.0481 2.259-4.96786 1.1405-7.59953-1.5852-3.72998-5.89399-5.468659-9.62396-3.88346zm7.21186 11.02429c1.6755-1.7048 2.2547-4.31524 1.2617-6.65191-1.3152-3.09462-4.89004-4.53714-7.98466-3.22196s-4.53714 4.89003-3.22196 7.98467c1.31519 3.0946 4.89003 4.5371 7.98462 3.2219.7252-.3081 1.3596-.7404 1.8891-1.2615.0108-.0127.0223-.0251.0344-.0372.0119-.0119.0242-.0233.0368-.034z","fillRule":"evenodd"}));
}

SearchInline.defaultProps = {"height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
